import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createPromo, getPromos } from "../services/admin.promos.service";
import { useToast } from "../context/ToastContext";
import PromoCreateModal from "../components/promo/PromoCreateModal";
import PromoHeader from "../components/promo/PromoHeader";
import PromoTable from "../components/promo/PromoTable";


export default function Promos() {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const [data, setData] = useState({ data: [], last_page: 1, total: 0 });
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
   const [openCreate, setOpenCreate] = useState(false);

  const [statusFilter, setStatusFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");

  useEffect(() => {
    loadPromos();
  }, [page, search, statusFilter, typeFilter]);

  async function loadPromos() {
    setLoading(true);
    try {
      const filters = {
        search,
        status: statusFilter,
        type: typeFilter, // On envoie le type au backend
      };
      const response = await getPromos(page, filters);
      setData(response);
    } catch (err) {
      showToast("Erreur de chargement", "error");
    } finally {
      setLoading(false);
    }
  }
   async function handleCreate(payload) {
      try {
        await createPromo(payload);
        showToast("Code Promo enregistré avec succès", "success"); 
        setOpenCreate(false);
        setPage(1);
        loadPromos();
      } catch (err) {
        showToast(
          err.response?.data?.message || "Erreur lors de l'envoi",
          "error",
        );
      }
    }
  if (loading && data.data.length === 0) {
    return <div className="loaderContainer">Chargement des promotions...</div>;
  }

  return (
    <div className="page">
      <PromoHeader
        total={data.total}
        search={search}
        onSearch={(val) => {
          setSearch(val);
          setPage(1);
        }}
        statusFilter={statusFilter}
        onStatusChange={(val) => {
          setStatusFilter(val);
          setPage(1);
        }}
        typeFilter={typeFilter}
        onTypeChange={(val) => {
          setTypeFilter(val);
          setPage(1);
        }}
         onAdd={() => setOpenCreate(true)}
      />

      <PromoTable
        promos={data.data}
        onView={(p) => navigate(`/promotions/${p.id}`)}
        onDelete={(id) => console.log("Supprimer", id)}
      />
      <PromoCreateModal
        open={openCreate}
        onClose={() => setOpenCreate(false)}
        onSubmit={handleCreate}
      />
      <div className="paginationContainer">
        <div className="pagiInfo">
          Page <strong>{page}</strong> sur {data.last_page}
        </div>
        <div className="pagiControls">
          <button
            className="pagiBtn"
            disabled={page === 1}
            onClick={() => setPage((p) => p - 1)}
          >
            Précédent
          </button>
          <button
            className="pagiBtn"
            disabled={page === data.last_page}
            onClick={() => setPage((p) => p + 1)}
          >
            Suivant
          </button>
        </div>
      </div>
    </div>
  );
}
